"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _initialsPlaceholder = _interopRequireDefault(require("../styles/initialsPlaceholder"));

function InitialsPlaceholder(a) {
  var b = a.string,
      c = a.size,
      d = a.fontSize,
      e = b.match(/\b(\w)/g) || [];
  if (!e.length) return null;
  var f = e.slice(0, 2).join("");
  return _react["default"].createElement("div", {
    className: _initialsPlaceholder["default"],
    style: {
      width: c,
      height: c,
      fontSize: d
    }
  }, _react["default"].createElement("span", null, f.toUpperCase()));
}

var _default = (0, _react.memo)(InitialsPlaceholder);

exports["default"] = _default;